import styled from 'styled-components'

type VideoUiProps = {
  disabledPointerEvents: boolean
}

const VideoUi = styled.div<VideoUiProps>`
  'video::-internal-media-controls-download-button' {
    display: none;
  }
  'video::-webkit-media-controls-enclosure' {
    overflow: hidden;
  }
  'video::-webkit-media-controls-panel' {
    width: calc(100% + 30px);
  }

  position: relative;
  padding-top: 56.36%; // NOTE: 100:56.36 = 16:9 (the most popular aspect ratio)

  ${p => p.disabledPointerEvents && `pointer-events: none;`}

  .react-player {
    position: absolute;
    top: 0;
    left: 0;
    overflow: hidden;
  }
`

export default VideoUi
